import { authApi } from './auth/authApi';
import { userApi } from './user/userApi';
import { userAddressApi } from './user/userAddressApi';
import { adminApi } from './admin/adminApi';
import { configApi } from './configuration/configApi';
import { flowApi } from './flow/flowApi';
import { dashboardApi } from './dashboard/dashboardApi';
import { orderApi } from './order/orderApi';
import { transactionHistoryApi } from './transactionHistory/transactionHistoryApi';
import { promotionApi } from './promotion/promotionApi';

const dataProvider = {
  ...authApi,
  ...userApi,
  ...userAddressApi,
  ...adminApi,
  ...configApi,
  ...flowApi,
  ...dashboardApi,
  ...orderApi,
  ...transactionHistoryApi,
  ...promotionApi,

  // Methods not implemented or stubbed
  getOne: () => Promise.resolve({ data: {} }),
  getMany: () => Promise.resolve({ data: [] }),
  getManyReference: () => Promise.resolve({ data: [], total: 0 }),
  updateMany: () => Promise.resolve({ data: [] }),
  deleteMany: () => Promise.resolve({ data: [] }),
};

export default dataProvider;